import { render, staticRenderFns } from "./rPage.vue?vue&type=template&id=88c03b56"
import script from "./rPage.vue?vue&type=script&lang=js"
export * from "./rPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports